module.exports = __webpack_public_path__ + "static/media/Constitution of India.80aade51.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PHIL/Constitution of India.pdf
// module id = 153
// module chunks = 0